module.exports = __webpack_public_path__ + "8ec89bcf.csv";